import BaseModel from "@/store/models/base";
import PaymentOptionBankAccountModel from "./payment-option-bank-account";
import PaymentOptionInstallmentModel from "./payment-option-installment";

export default class PaymentOptionModel extends BaseModel {
  getSchema() {
    return {
      id: "",
      name: "",
      installments: [],
      bank_accounts: [],
    };
  }

  /**
   * Retorna as contas bancárias disponíveis.
   *
   * @return {Array<PaymentOptionBankAccountModel>}
   * */
  get bank_accounts() {
    return this.rawAttributes.bank_accounts;
  }

  /**
   * Retorna as opções de parcelamento.
   *
   * @return {Array<PaymentOptionInstallmentModel>}
   * */
  get installments() {
    return this.rawAttributes.installments;
  }

  /**
   * Transforma a lista de contas bancárias fornecida
   * em uma lista do tipo PaymentOptionBankAccountModel.
   *
   * @return {Array<PaymentOptionBankAccountModel>}
   * */
  mutateBankAccounts(items) {
    return (Array.isArray(items) ? items : []).map(
      (item) => new PaymentOptionBankAccountModel(item)
    );
  }

  /**
   * Transforma a lista de opções de parcelamento fornecida
   * em uma lista do tipo PaymentOptionInstallmentModel.
   *
   * @return {Array<PaymentOptionInstallmentModel>}
   * */
  mutateInstallments(items) {
    return (Array.isArray(items) ? items : []).map(
      (item) => new PaymentOptionInstallmentModel(item)
    );
  }

  /**
   * Determina se o método de pagamento possui contas para deposíto.
   *
   * @return {boolean}
   * */
  hasBankAccounts() {
    return this.bank_accounts.length > 0;
  }
}
